// src/admin/AdminNav/pages/FoodItemsPage.jsx

import React, {useState, useRef} from "react";
import {supabase} from "../../../../supabaseClient";
import "./FoodItemsPage.css";

function FoodItemsPage() {
    const [foodName, setFoodName] = useState("");
    const [foodImage, setFoodImage] = useState(null);
    const fileRef = useRef(null);

    const handleCreateFoodItem = async (e) => {
        e.preventDefault();

        if (!foodName.trim()) {
            console.log("Invalid food name!");
            return;
        }

        try {
            console.log("Inserting into 'fooditems' with name =", foodName);

            // 1) Insert the row { name: foodName } into "fooditems"
            const {data: insertData, error: insertError} = await supabase
                .from("fooditems")
                .insert([{name: foodName}])
                .select();

            console.log("Insert result => data:", insertData, "error:", insertError);

            if (insertError) {
                console.error("Error inserting item:", insertError);
                alert("Kunde inte lägga till matvaran. Se konsolen för detaljer.");
                return;
            }

            if (!insertData || insertData.length === 0) {
                alert("Ingen rad lades till i tabellen. Kolla ev. RLS/policys.");
                return;
            }

            // The new row from the DB, e.g. { id: 164, name: "Rice" }
            const createdItem = insertData[0];

            // 2) If user selected an image, upload it to "product-images" with the new ID
            if (foodImage) {
                const ext = foodImage.name.split(".").pop();
                const newFoodId = createdItem.id; // e.g. 164
                const fileName = `foodid_${newFoodId}.${ext}`; // e.g. "foodid_164"

                console.log("Uploading image to bucket with file name:", fileName);

                const {data: uploadData, error: uploadError} = await supabase.storage.from("product-images").upload(fileName, foodImage);

                if (uploadError) {
                    console.error("Error uploading file:", uploadError);
                    alert("Matvaran lades till, men bild-uppladdningen misslyckades.");
                } else {
                    console.log("Upload success =>", uploadData);
                    alert(`"${foodName}" har lagts till i fooditems-tabellen och bilden har laddats upp!`);
                }
            } else {
                // No image selected, just confirm success
                alert(`"${foodName}" har lagts till i fooditems-tabellen!`);
            }

            // 3) Clear the form
            setFoodName("");
            setFoodImage(null);
            if (fileRef.current) {
                fileRef.current.value = "";
            }
        } catch (err) {
            console.error("Unexpected error creating item:", err);
            alert("Ett oväntat fel uppstod vid skapande av matvaran.");
        }
    };

    return (
        <div className="food-items-container">
            <h2 className="food-items-title">Lägg till Matvara</h2>

            <form className="food-item-form" onSubmit={handleCreateFoodItem}>
                <label>
                    Namn:
                    <input type="text" value={foodName} onChange={(e) => setFoodName(e.target.value)} required />
                </label>

                <label>
                    Bild (valfri):
                    <input type="file" accept="image/*" ref={fileRef} onChange={(e) => setFoodImage(e.target.files[0])} />
                </label>

                <button type="submit">Lägg till</button>
            </form>
        </div>
    );
}

export default FoodItemsPage;
